// Libraries
var React = require('react');

// Styles
require('./Dash.scss');

class Dash extends React.Component {
    render() {
        let iconWidth = 35;
        return (
            <div className="Dash" style={{ left: this.props.position + (iconWidth / 2) }}></div>
        )
    }
}

module.exports = Dash;


// WEBPACK FOOTER //
// ./src/components/MDC/Timeline/Dash.js